<div class="modal-wrapper">
  <div class="modal-header modal-header--custom">
    <div class="modal-header__title">
      <div class="modal-icon"><mat-icon>group</mat-icon></div>
      <h4>{{ formMode }} Group</h4>
    </div>
    <button mat-icon-button class="modal-close-btn" (click)="activeModal.close('close')" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body modal-form-body">
    <form [formGroup]="entryForm" novalidate>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Group Name</mat-label>
        <input matInput formControlName="group_name"
               placeholder="Enter group name"
               [readonly]="editGroup" />
        @if (entryForm.controls['group_name'].hasError('required')) {
          <mat-error>Group Name is required</mat-error>
        }
        @if (entryForm.controls['group_name'].hasError('cannotContainSpace')) {
          <mat-error>Group Name cannot contain spaces</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Description</mat-label>
        <input matInput formControlName="Description" placeholder="Enter description" />
        @if (entryForm.controls['Description'].hasError('required')) {
          <mat-error>Description is required</mat-error>
        }
      </mat-form-field>
    </form>

    @if (editGroup && group) {
      <app-group-details-list [group]="group" [applicationName]="applicationName">
      </app-group-details-list>
    }
  </div>

  <div class="modal-footer modal-footer--custom">
    @if (!editGroup) {
      <button mat-flat-button color="primary" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="onCreate_Update()">
        <mat-icon>add</mat-icon> Create
      </button>
    }
    @if (editGroup) {
      <button mat-stroked-button color="warn" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="openConfirmModal('Are you sure you want to Delete?')">
        <mat-icon>delete</mat-icon> Delete
      </button>
    }
  </div>
</div>
